import React from 'react';
import {Button, Typography} from 'onboarding-components';
import produce from 'immer';

import {SetupGuideContext, Step} from 'common/onboarding/immersive-onboarding/types';
import {track, TrackingEvent, TrackingProperty} from 'common/onboarding/immersive-onboarding/tracking';
import {SummaryTable} from 'common/onboarding/immersive-onboarding/components';
import {ApiClient} from 'common/onboarding/immersive-onboarding/api-client';
import {useTranslation} from 'common/i18n/hooks';

import styles from './welcome-v2.module.styl';
import {FooterActionBar} from './footer-action-bar';

export const WelcomeWithPlannedEvents: React.FC = () => {
  const {t} = useTranslation();
  const {setStep, setupGuideInfo, setSetupGuideInfo} = React.useContext(SetupGuideContext);

  return (
    <div className={styles.welcomeContent}>
      <div className={styles.connectDataWrapper}>
        <div className={styles.connectDataCtaBox}>
          <div className={styles.connectDataText}>
            <Typography className={styles.noMargin} variant='headingSm' weight='bold'>
              {t(`onboarding.welcome.unlock-insights`)}
            </Typography>
            <Typography className={styles.subTitle} variant='bodySm'>
              {t(`onboarding.welcome.connect-guide`)}
            </Typography>
          </div>
          <div>
            <Button
              size='medium'
              onClick={() => {
                // TODO (Sonya) - distill this to one function
                const updatedStepsCompleted = produce(setupGuideInfo.stepsCompleted, (draft) => {
                  draft.add(Step.Welcome);
                });
                ApiClient.updateCompleted(setupGuideInfo.projectId, updatedStepsCompleted);
                setSetupGuideInfo({...setupGuideInfo, stepsCompleted: updatedStepsCompleted});

                setStep(Step.Implement);
                track(TrackingEvent.WelcomeConnectDataClick, {
                  [TrackingProperty.CurrentStep]: Step.Welcome,
                  [TrackingProperty.Phase2]: true,
                  [TrackingProperty.WelcomeVariant]: `with-table`,
                });
              }}
            >
              {t(`onboarding.welcome.connect-data`)}
            </Button>
          </div>
        </div>
        <SummaryTable
          onEdit={() => {
            setStep(Step.Events);
            track(TrackingEvent.SummaryTableEditClick, {[TrackingProperty.Phase2]: true});
          }}
        />
      </div>
      <div className={styles.footerActionBarWrapper}>
        <FooterActionBar />
      </div>
    </div>
  );
};
